import { Section, H2, CheckList } from "../../components/common-components";

export const PharmacyUseOnly = ({ formType }) => {
    const pharmacyUseOptions = [
        { 
            label: "Change Rx: Update Rx, not filled as prescribed", 
            value: "change-update",
            checked: false
        },
        { 
            label: "No Change to Rx: Continue with original Rx", 
            value: "no-change",
            checked: false
        },
        { 
            label: "Change Rx: Change Drug, Dose, or Regimen", 
            value: "change-drug",
            checked: false
        }
    ];

    return (
        <Section formType={formType}>
            <div>
                <div className="flex items-start">
                    <div className="flex-1">
                        <H2 className="text-xs text-teal-300 whitespace-nowrap font-semibold">Pharmacy Use Only - Select Only One Outcome</H2>
                        <div className=" mt-1 space-y-0.5">
                            {pharmacyUseOptions.map((option, index) => (
                                <div key={index} className="flex items-center justify-between">
                                    <div className="">
                                        <div className="flex items-center space-x-2 pr-2">
                                            <CheckList list={[{ label: option.label, checked: option.checked }]} />
                                        </div>
                                    </div>
                                    <span className="text-xs text-gray-500 ml-4">{option.pin}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="flex-0.8">
                        <div className="flex items-start ">
                            <span className="text-teal-300 text-sm">*</span>
                            <span className="text-teal-300 text-xs font-semibold whitespace-nowrap">
                                This form must be cross referenced to the pharmacy hardcopy --Rx/Ttx
                            </span>
                        </div>
                        <div className="mt-0">
                            <span className="text-gray-800 text-xs">PIN: 93899991</span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 text-xs">PIN: 93899992</span>
                        </div>
                        <div className="">
                            <span className="text-gray-800 text-xs">PIN: 93899993</span>
                        </div>
                    </div>
                </div>
            </div>
        </Section>
    );
};
